import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ComProductSharedModel } from 'src/app/model/com-product-shared.model';

@Injectable({
  providedIn: 'root'
})
export class ComProductSharedService {
  private url:string;

  ////////////////
  constructor(
    private http:HttpClient
  ) {
    this.url=environment.services_url;
  }

  //
  getAll=()=> {
    return this.http.get(`${this.url}/CommissionProductShared/List`)
      .pipe(
        map((resp:any)=> resp)
      );
  }


  save=(commission:ComProductSharedModel)=> {
    return this.http.post(`${this.url}/CommissionProductShared/SaveUpdate`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  saveAll=(commissions:ComProductSharedModel[])=> {
    return this.http.post(`${this.url}/CommissionProductShared/saveAll`, commissions)
      .pipe(
        map((resp:any)=> resp)
      );
  }
  update=(commission:ComProductSharedModel)=> {
    return this.http.post(`${this.url}/CommissionProductShared/SaveUpdate/${commission.sharedCommissionId}`, commission)
      .pipe(
        map((resp:any)=> resp)
      );
  }
}
